module.exports = __webpack_public_path__ + "media/images/fishes/fish-tank-substrate-depth.jpg";